// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedProductPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import {
    getComputedVariantProduct,
    getProductState,
    getProductStateByPath,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { MultiLocationCatalogInfo } from "@store/Framework/Store/Greif/Pages/ProductDetails/ProductDetailsReducer";

/**
 * Returns the multi-location catalog info for the selected product on the product details page.
 * @param state The application state.
 */
export function getProductDetailMultiLocationCatalogInfo(
    state: ApplicationState,
): MultiLocationCatalogInfo | undefined {
    const productId = getProductId(state);
    return productId && state.greif.pages.productDetails.multiLocationCatalogInfoByProductId
        ? state.greif.pages.productDetails.multiLocationCatalogInfoByProductId?.[productId]
        : undefined;
}

/**
 * This function replicates what Optimizely does to get the product ID for the selected product on the product details page.
 */
function getProductId(state: ApplicationState): string | undefined {
    const location = getLocation(state);
    let productPath =
        getSelectedProductPath(state) ||
        (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);
    if (location.pathname.toLowerCase().startsWith("/content/page/") && productPath.indexOf("?") > -1) {
        productPath = productPath.substring(0, productPath.indexOf("?"));
    }
    const productState = getProductStateByPath(state, productPath);
    const variantProductState = getProductState(state, state.pages.productDetails.selectedProductId);
    const computedVariantProduct = getComputedVariantProduct(productState, variantProductState);

    return computedVariantProduct?.value?.id;
}
